document.addEventListener("DOMContentLoaded", function () {
  const videoContainers = document.querySelectorAll(".video-container");
  let currentlyPlaying = null;

  // Function to reset a video to its initial state
  function resetVideo(container) {
    if (!container) return;

    const video = container.querySelector(".review-video");
    const playButton = container.querySelector(".play-button");

    video.pause();
    video.currentTime = 0;
    video.controls = false;
    playButton.style.display = "flex";
  }

  // Function to disable fullscreen on a video
  function disableFullscreen(video) {
    // Disable fullscreen via keyboard
    video.addEventListener("keydown", function (e) {
      if (e.key === "f" || e.key === "F" || e.keyCode === 70) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });

    // Disable fullscreen via double-click
    video.addEventListener("dblclick", function (e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    // Monitor for fullscreen changes and exit if triggered
    const exitFullscreen = () => {
      if (
        document.fullscreenElement === video ||
        document.webkitFullscreenElement === video ||
        document.mozFullScreenElement === video ||
        document.msFullscreenElement === video
      ) {
        // Exit fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    };

    // Listen for fullscreen changes
    document.addEventListener("fullscreenchange", exitFullscreen);
    document.addEventListener("webkitfullscreenchange", exitFullscreen);
    document.addEventListener("mozfullscreenchange", exitFullscreen);
    document.addEventListener("MSFullscreenChange", exitFullscreen);
  }

  videoContainers.forEach((container) => {
    const video = container.querySelector(".review-video");
    const playButton = container.querySelector(".play-button");

    // Disable fullscreen functionality
    disableFullscreen(video);

    // Force Safari to load thumbnail
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      video.addEventListener(
        "loadedmetadata",
        function () {
          video.currentTime = 0.1;
          video.addEventListener(
            "seeked",
            function () {
              video.currentTime = 0;
            },
            { once: true }
          );
        },
        { once: true }
      );

      // Force load
      setTimeout(() => video.load(), 100);
    }

    playButton.addEventListener("click", function () {
      // If there's another video playing, reset it first
      if (currentlyPlaying && currentlyPlaying !== container) {
        resetVideo(currentlyPlaying);
      }

      currentlyPlaying = container;

      // Enable controls and hide play button
      video.controls = true;
      playButton.style.display = "none";

      // Unmute and play
      video.muted = false;
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Video play failed:", error);
          playButton.style.display = "flex";
          video.controls = false;
          currentlyPlaying = null;
        });
      }
    });

    // Disable right-click context menu
    video.addEventListener("contextmenu", function (e) {
      e.preventDefault();
      return false;
    });

    // Show play button when video ends
    video.addEventListener("ended", function () {
      video.muted = true; // Re-mute for Safari
      resetVideo(container);
      currentlyPlaying = null;
    });

    // Handle loading errors
    video.addEventListener("error", function (e) {
      console.error("Video loading error:", e);
    });
  });

  // Reset all videos when clicking outside
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".video-container") && currentlyPlaying) {
      const video = currentlyPlaying.querySelector(".review-video");
      video.muted = true;
      resetVideo(currentlyPlaying);
      currentlyPlaying = null;
    }
  });
});
